// /oversea/seckill/mainvenue

export interface SkuInfoItemType {
  biddingNo: string // 出价编号
  imgUrl: string
  marketingPrice: number // 活动价格
  noticeFlag: 1 | 2 // 1:已提醒；2 未提醒；未登录返回2
  orderNo: number // 排序
  salePrice: number // 划线价格
  skuId: number
  skuProperty: string // sku属性
  spuId: number
  totStock: number // 总库存
  stock: number // 库存
  title: string //
  [key: string]: any
}

export interface MarkInfoItemType {
  begTime: number // 开始时间
  endTime: number // 结束时间
  jumpUrl: string // 跳链url
  venueId: number // 当前会场id
  stockFlag: number // 1：已售罄存在冷静期；2：已售罄不存在冷静期；
  venueSkuInfoList: SkuInfoItemType[] // 活动商品list
}

export interface MainvenueResType {
  data: {
    markInfoList: MarkInfoItemType[]
    domain?: string
    msg?: string
    status: number
  }
}

export interface MainvenueReqType {
  countryCode: string
  currencyCode: string
  language: string
  timeZone?: string
  uid?: number
  venueId?: number
}

export interface VenueItemReqType {
  countryCode: any
  currencyCode: any
  language: any
  // timeZone: any
  venueId: any
}

export interface VenueItemResType {
  data: MarkInfoItemType
  code: number
  msg?: string
}

export enum StatusMap {
  over = 1, // 搶完了
  end = 2, // 已結束
  ing = 3, // 搶購中
  aboutOf = 4, // 即將開始
}

export enum BtnStatusMap {
  saleOver = 'saleOver', // 抢完了
  goBuy = 'goBuy', // 去购买
  isSetting = 'isSetting', // 提醒已设置
  remind = 'remind', // 去提醒
}

export interface TabItemType {
  index: number
  title: string
  status: StatusMap // 搶完了 已結束 搶購中 即將開始
  date?: string // 日期
  venueId?: number // 会场ID
  [key: string]: any
}

export interface ProductItemContextType {
  moneySymbol: string
  btnStatusMap: {
    [key in BtnStatusMap]: string
  }
  tabItem?: TabItemType
  [key: string]: any
}
